import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { BrowserProvider } from './contexts/BrowserContext';
import router from './router';
import { applyTheme, getStoredThemeMode } from './components/hooks/useTheme';
import { queryClient } from './queryClient';
import LegacyDomainMigrator from './components/auth/LegacyDomainMigrator';
import { LEGACY_DOMAIN_MIGRATION_ENABLED, LEGACY_PLATFORM_ORIGIN } from './constants';
import { isLegacyPlatformLocation } from './components/auth/legacyDomainMigrationPolicy';
import { isExtensionRuntime } from './utils/appSurface';

// Apply persisted theme before first render to prevent flash
applyTheme(getStoredThemeMode());

function App() {
  const extensionRuntime = isExtensionRuntime();
  const appSurface = extensionRuntime ? 'extension' : 'web';

  if (
    !extensionRuntime &&
    isLegacyPlatformLocation(
      window.location.origin,
      LEGACY_PLATFORM_ORIGIN,
      LEGACY_DOMAIN_MIGRATION_ENABLED,
    )
  ) {
    return <LegacyDomainMigrator />;
  }

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserProvider>
        <div className="ui-root" data-app-surface={appSurface}>
          <div className="ui-panel ui-layer-panel pointer-events-auto relative flex h-[100dvh] w-[var(--prismancy-panel-width)] shrink-0 flex-col overflow-hidden bg-background-surface-01 text-[var(--prismancy-black)] shadow-[-4px_0_10px_0_var(--ui-shadow-xs)] transition-[transform,width] duration-200 [transition-timing-function:var(--prismancy-transition-timing-function)] will-change-transform">
            <RouterProvider router={router} future={{ v7_startTransition: true }} />
          </div>
        </div>
      </BrowserProvider>
    </QueryClientProvider>
  );
}

export default App;
